import { Translate } from '@chipinside/translate'

import { ImportSpreadsheetTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

interface IParams {
  spreadsheet: ImportSpreadsheetTypeConfig
}

export const buildSpreadsheetField = ({ spreadsheet }: IParams) => ({
  label: Translate({ messageKey: 'select_spreadsheet_type' }),
  name: spreadsheet.name,
  options: spreadsheet.options.map(option => ({
    label: Translate({ messageKey: option.labelKey }),
    value: option.value,
  })),
  type: 'choice',
  value: spreadsheet.defaultValue,
})
